// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"6abca01a","213":"676c1fdc","337":"bb1ebf71","453":"21e2d01d","667":"7d85d597"}[chunkId] + ".chunk.js";
};